// Deep imports rather than the `@/features/hazards` barrel. The barrel exports `./data` before
// `./domain`, so a mapper reaching back through it for an enum is evaluated while `./domain` is
// still initialising and sees `undefined` — which makes this module, and anything importing it,
// impossible to load in isolation (KUDO1-9541).
import { HAZARD_MARKERS } from '@/features/hazards/utils/constants';
import { OtherIncidentSubType } from '@/features/hazards/domain/entities/types/other-incidents';
import type { Scheme } from '@/features/hazards/domain/entities/types/scheme';

// TODO: This is probably safe to remove since we have introduced the usage of the `incident-icon` property
type OtherIncidentsToSchemeMap = Record<OtherIncidentSubType, Scheme>;

export const otherIncidentsToSchemeMap: OtherIncidentsToSchemeMap = {
  [OtherIncidentSubType.SmellOfGasOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-smell-of-gas'],
  },
  [OtherIncidentSubType.StructureDamageOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-structure-damage'],
  },
  [OtherIncidentSubType.ActiveAlarmOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-active-alarm'],
  },
  [OtherIncidentSubType.BurnOffOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-burn-off'],
  },
  [OtherIncidentSubType.FuelLeakOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-fuel-leak'],
  },
  [OtherIncidentSubType.ReportOfSmokeOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-report-of-smoke'],
  },
  [OtherIncidentSubType.RoadCrashOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-road-crash'],
  },
  [OtherIncidentSubType.VehicleFireOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-vehicle-fire'],
  },
  [OtherIncidentSubType.FireOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-fire'],
  },
  [OtherIncidentSubType.PrescribedBurnOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-prescribed-burn'],
  },
  [OtherIncidentSubType.FloodOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-flood'],
  },
  [OtherIncidentSubType.CycloneOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-cyclone'],
  },
  [OtherIncidentSubType.EarthquakeOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-earthquake'],
  },
  [OtherIncidentSubType.TsunamiOtherIncidentEntity]: {
    icon: HAZARD_MARKERS['ew-other-tsunami'],
  },
};
